import { Component } from '@angular/core';
import { DevModeService } from '../../dev-mode.service';

@Component({
  standalone: false,
  selector: 'app-dev-mode-badge',
  templateUrl: './dev-mode-badge.template.html',
  styleUrls: ['./dev-mode-badge.style.scss']
})
export class DevModeBadgeComponent {
  constructor(public devMode: DevModeService) {}

  disable() {
    this.devMode.disable();
  }
}
